import { render, staticRenderFns } from "./RecipeCategoryItem.vue?vue&type=template&id=88276dba&"
import script from "./RecipeCategoryItem.vue?vue&type=script&lang=js&"
export * from "./RecipeCategoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports